const EventSubscribe = (target) => {
  const method = {
    init: () => {
      if (target) {
        const form = target;

        form.addEventListener("submit", (e) => {
          e.preventDefault();
          // console.log(`submitting form `, target);
          method.recaptcha(form);
        });
      }
    },

    recaptcha: (form) => {
      var recaptchaElement = form.querySelector('[name="g-Recaptcha-Response"]');
      if (recaptchaElement != null) {
        grecaptcha.ready(() => {
          grecaptcha.execute('6LdYiEklAAAAACaWn0TAvnctGISMYyrZi3rprVEx', { action: 'submit' }).then((token) => {
            recaptchaElement.value = token;
            method.submit(form);
          });
        });
      } else {
        method.submit(form);
      }
    },

    submit: async (form) => {
      const button = form.querySelector("button[type=submit]");
      const callout = form.querySelectorAll(".callout");
      const data = new FormData(form);
      const action = form.getAttribute("action");
      const formMethod = form.getAttribute("method");
      const eventId = form.querySelector(`[name="EventId"]`);

      if (callout) {
        callout.forEach((el) => el.remove());
      }

      button.disabled = true;
      button.classList.add("button--loading");

      fetch(action, {
        method: formMethod,
        body: data,
      })
        .then((res) => res.json())
        .then((response) => {
          if (response.success) {
            let successMessage = response.message;
            if (response.full) {
              method.renderMessage(form, successMessage, "success");
            } else {
              method.renderMessage(form, successMessage, "info");
            }
            const calendar = document.querySelector(`[data-calendar='${eventId.value}']`);
            if (calendar) {
              calendar.style.display = "";
              calendar.style.visibility = "visible";
            }
            form.reset();
          } else {
            method.renderMessage(form, response.message, "error");
          }
          setTimeout(() => {
            button.classList.remove("button--loading");
            button.disabled = false;
          }, 150);
        })
        .catch((ex) => {
          method.renderMessage(form, `Server error: ${ex}`, "error");
        });
    },

    renderMessage: (el, message, type) => {
      el.insertAdjacentHTML(
        "beforeend",
        `<div class="callout callout--${type}">${message}</div>`
      );
    },

    renderFull: (form) => {
      const fullElement = form.querySelector(".event-sign-up__full");
      const h6 = document.createElement("h6");
      h6.appendChild(document.createTextNode(fullElement.dataset.fullText));

      fullElement.prepend(h6);
      fullElement.style.display = "block";
    },
  };

  method.init();
};

export default EventSubscribe;
